import { cn } from "@/shared/utils/cn";
import React from "react";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  as?: "input" | "textarea";
  variant?: "primary" | "secondary";
}

const Input = React.forwardRef<HTMLInputElement, InputProps>((props, ref) => {
  const { variant = "primary", as = "input", className = "", ...rest } = props;

  const sharedClassName = cn(
    "max-w-full  p-[0.5rem] text-[var(--text)] outline-none transition-all placeholder:text-[var(--text)] placeholder:opacity-60 focus:shadow-[0_0_0_0.1rem_var(--primary)] disabled:cursor-not-allowed disabled:bg-grey disabled:opacity-60",
    variant === "secondary"
      ? "min-w-0 max-w-full box-border rounded-md border-r border-border/70 bg-transparent"
      : "rounded-[0.5rem] border border-[rgba(0,0,0,0.2)] bg-[var(--input)] shadow-[0_2px_8px_#999]"
  );
  const inputClassName = `h-[3.8rem] ${sharedClassName}`;
  // Fixed height on inputs; textareas use native `rows` height — h-[3.8rem] would override that.
  const textareaClassName = sharedClassName;

  if (as === "textarea") {
    return (
      <textarea
        ref={ref as unknown as React.Ref<HTMLTextAreaElement>}
        className={`${textareaClassName} ${className}`}
        {...(rest as unknown as React.TextareaHTMLAttributes<HTMLTextAreaElement>)}
      />
    );
  }

  return (
    <input
      ref={ref}
      className={`${inputClassName} ${className}`}
      {...rest}
    />
  );
});

export default Input;
